import { compose, mapProps } from 'recompose'
import withAddToQuote from 'components/common/hoc/withAddToQuote/withAddToQuote'
import withCheckActiveVehicle from 'components/common/hoc/withCheckActiveVehicle'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import AddToQuoteButton from './AddToQuoteButton'

export default compose(
  withShowConfirmTireSizeModalPreconfigured,
  mapProps(({ onClick, ...props }) => ({ noTireSizeOnClick: onClick, preventNavigation: true, ...props })),
  withAddToQuote,
  withCheckActiveVehicle
)(AddToQuoteButton)
